import React from 'react'
import { STEP_LABELS } from 'slices/onboardingSlice'
import { Check } from 'lucide-react'

interface OnboardingProgressProps {
	currentStep: number
	totalSteps?: number
}

const OnboardingProgress: React.FC<OnboardingProgressProps> = ({
	currentStep,
	totalSteps = STEP_LABELS.length,
}) => {
	return (
		<div className="flex items-center justify-center gap-1 py-3 px-4">
			{Array.from({ length: totalSteps }, (_, i) => {
				const isCompleted = i < currentStep
				const isCurrent = i === currentStep

				return (
					<React.Fragment key={i}>
						<div className="flex flex-col items-center gap-1">
							<div
								className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-medium transition-colors ${
									isCompleted
										? 'bg-[#0080fe] text-white'
										: isCurrent
											? 'bg-[#0080fe]/10 text-[#0080fe] ring-2 ring-[#0080fe]'
											: 'bg-gray-100 text-gray-400'
								}`}
							>
								{isCompleted ? <Check className="w-3.5 h-3.5" /> : i + 1}
							</div>
							<span
								className={`text-[10px] font-medium ${
									isCurrent ? 'text-[#0080fe]' : isCompleted ? 'text-gray-600' : 'text-gray-400'
								}`}
							>
								{STEP_LABELS[i]}
							</span>
						</div>
						{i < totalSteps - 1 && (
							<div
								className={`flex-1 h-0.5 min-w-[20px] mt-[-14px] ${
									isCompleted ? 'bg-[#0080fe]' : 'bg-gray-200'
								}`}
							/>
						)}
					</React.Fragment>
				)
			})}
		</div>
	)
}

export default OnboardingProgress
